import { Request } from "./HttpService";

export const GeneralService = {
  getUserInformations: function () {
    return Request("vitae/general/getUserInformations", "GET");
  },
  getVitaeLanguages: function () {
    return Request("vitae/general/getVitaeLanguages", "GET");
  },
  getAllCompanies: function () {
    return Request("vitae/company", "GET");
  },
  getAllAvailableCompanies: function () {
    return Request("vitae/company/all", "GET");
  },
  getAllUserCompanies: function () {
    return Request("vitae/company/usercompanies", "GET");
  },

  getAllCompaniesWebDocs: function () {
    return Request("vitae/company/webDocs", "GET");
  },
  getCurrentUser: function () {
    return Request("vitae/general/getCurrentUser", "GET");
  },
  getCountries: function () {
    return Request("vitae/general/Countries", "GET");
  },
  gettypeOfPermit: function () {
    return Request("vitae/general/typeOfPermit", "GET");
  }
};
